<template>
  <div>
    <div class="crumbs">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item>
          <i class="el-icon-lx-cascades"></i> 基础表格
        </el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="container">
      <div class="handle-box">
        <el-input
          v-model="query.keyWord"
          placeholder="关键词"
          class="handle-input mr10"
        ></el-input>
        <el-button
          type="primary"
          icon="el-icon-search"
          @click="handleSearch"
        >搜索</el-button>
        <el-button
          type="primary"
          icon="el-icon-plus"
          @click="addVisible=true"
        >增加</el-button>
      </div>
      <el-table
        :data="tableData"
        border
        class="table"
        ref="multipleTable"
        header-cell-class-name="table-header"
        @selection-change="handleSelectionChange"
      >
        <el-table-column
          type="selection"
          width="55"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="id"
          label="ID"
          width="100"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="username"
          label="用户名"
        ></el-table-column>
        <el-table-column
          label="权限"
        >

           <template #default="scope">
               <span>{{scope.row.auth_role_user?scope.row.auth_role_user.auth_role.name:'无角色'}}</span>
           </template>

        </el-table-column>
        <el-table-column
          label="操作"
          width="180"
          align="center"
        >
          <template #default="scope">
            <el-button
              type="text"
              icon="el-icon-edit"
              @click="handleEdit(scope.$index, scope.row)"
            >重置密码</el-button>
            <el-button
              type="text"
              icon="el-icon-user"
              @click="handleBindUser(scope.$index, scope.row)"
            >账号权限</el-button>
            <el-button
              type="text"
              icon="el-icon-delete"
              class="red"
              @click="handleDelete(scope.$index, scope.row)"
            >删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="pagination">
        <el-pagination
          background
          layout="total, prev, pager, next"
          :current-page="query.pageIndex"
          :page-size="query.pageSize"
          :total="pageTotal"
          @current-change="handlePageChange"
        ></el-pagination>
      </div>
    </div>
    <!-- 增加弹出框 -->
    <el-dialog
      title="新增账号"
      v-model="addVisible"
      width="30%"
    >
      <el-form
        ref="form"
        :model="form"
        label-width="70px"
      >
        <el-form-item label="账号">
          <el-input v-model="newform.username"></el-input>

        </el-form-item>
        <el-form-item label="密码">

          <el-input v-model="newform.password"></el-input>
        </el-form-item>
      </el-form>
      <template #footer>
        <span class="dialog-footer">
          <el-button @click="addVisible = false">取 消</el-button>
          <el-button
            type="primary"
            @click="saveAdd"
          >确 定</el-button>
        </span>
      </template>
    </el-dialog>
    <!-- 编辑弹出框 -->
    <el-dialog
      title="编辑"
      v-model="editVisible"
      width="30%"
    >
      <el-form
        ref="form"
        :model="form"
        label-width="70px"
      >
        <el-form-item label="新密码">
          <el-input v-model="form.password"></el-input>
        </el-form-item>
      </el-form>
      <template #footer>
        <span class="dialog-footer">
          <el-button @click="editVisible = false">取 消</el-button>
          <el-button
            type="primary"
            @click="saveEdit"
          >确 定</el-button>
        </span>
      </template>
    </el-dialog>
    <!-- 绑定用户弹出框 -->
    <el-dialog
      title="绑定权限"
      v-model="bindUserVisible"
      width="50%"
    >
      <el-form
        ref="form"
        :model="form"
        label-width="70px"
      >
        <el-form-item label="当前角色">
          <span>{{bindUserForm.auth_role_user?bindUserForm.auth_role_user.auth_role.name:'无角色'}}</span>
        </el-form-item>
        <el-form-item label="角色权限">
          <el-select
            v-model="bindUserForm.role_id"
            placeholder="请选择角色"
          >
            <el-option
              v-for="(item,index) in roleList"
              :label="item.name"
              :value="item.id"
              :key="index"
            ></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <template #footer>
        <span class="dialog-footer">
          <el-button @click="bindUserVisible = false">取 消</el-button>
          <el-button
            type="primary"
            @click="saveRole"
          >确 定</el-button>
        </span>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import api from "@/api/index";
export default {
  name: "basetable",
  data() {
    return {
      query: {
        address: "",
        name: "",
        keyWord: "",
        pageIndex: 1,
        pageSize: 20,
      },
      tableData: [],
      multipleSelection: [],
      delList: [],
      editVisible: false,
      addVisible: false,
      bindUserVisible: false, //绑定用户的
      pageTotal: 0,
      form: {},
      newform: {},
      bindUserForm: {},
      roleList: [],
      idx: -1,
      id: -1,
      editUserId: "",
    };
  },
  created() {
    this.getPage();
    this.getRoleList();
  },
  methods: {
    getRoleList() {
      let data = {
        per_page: 100,
        page: 1,
      };

      api.rbacRole(data).then((res) => {
        console.log(res);
        this.roleList = res.data;
      });
    },
    //绑定用户的
    handleBindUser(index, row) {
      this.bindUserVisible = true;
      this.editUserId = row.id;
      this.bindUserForm = row;
    },
    //保存新增
    saveAdd() {
      api
        .manageAdd({
          username: this.newform.username,
          password: this.newform.password,
        })
        .then((res) => {
          if (res.status == 200) {
            this.$message.success("成功添加");
            this.getPage();
          }
        });
      this.addVisible = false;
    },
    saveRole() {
      api
        .rbacAuthRoleEdit({
          user_id: this.bindUserForm.id,
          role_id: this.bindUserForm.role_id,
        })
        .then((res) => {
          if (res.code == 200) {
            this.$message.success("成功");
            this.getPage();
            this.bindUserVisible = false;
          }
        });
    },
    // 获取 easy-mock 的模拟数据
    getPage() {
      let data = {
        per_page: this.query.pageSize,
        page: this.query.pageIndex,
      };
      if (this.query.keyWord) {
        data.keyword = this.query.keyWord;
      }
      api.manageList(data).then((res) => {
        console.log(res);
        this.tableData = res.data.data;
        this.pageTotal = res.data.total ;
      }).catch((e)=>{console.log(e)});
    },
    // 触发搜索按钮
    handleSearch() {
      this.query.pageIndex = 1;
      this.getPage();
    },
    // 删除操作
    handleDelete(index, row) {
      // 二次确认删除
      this.$confirm("确定要删除吗？", "提示", {
        type: "warning",
      })
        .then((re) => {
          console.log("tag", re);
          api
            .manageDel({
              id: row.id,
            })
            .then((res) => {
              if (res.status === 200) {
                this.$message.success("删除成功");
                this.getPage();
              }
            });
        })
        .catch(() => {});
    },
    // 多选操作
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    delAllSelection() {
      const length = this.multipleSelection.length;
      let str = "";
      this.delList = this.delList.concat(this.multipleSelection);
      for (let i = 0; i < length; i++) {
        str += this.multipleSelection[i].name + " ";
      }
      this.$message.error(`删除了${str}`);
      this.multipleSelection = [];
    },
    // 编辑操作
    handleEdit(index, row) {
      this.idx = row.id;
      this.form = row;
      this.editVisible = true;
    },
    // 保存编辑
    saveEdit() {
      api
        .manageUpdate({
          id: this.idx,
          password: this.form.password,
        })
        .then((res) => {
          if (res.status == 200) {
            this.$message.success(`修改成功`);
            this.getPage();
          }
        });

      this.editVisible = false;
    },
    // 分页导航
    handlePageChange(val) {
      this.query.pageIndex = val;
      this.getPage();
    },
  },
};
</script>

<style scoped>
.handle-box {
  margin-bottom: 20px;
}

.handle-select {
  width: 120px;
}

.handle-input {
  width: 300px;
  display: inline-block;
}
.table {
  width: 100%;
  font-size: 14px;
}
.red {
  color: #ff0000;
}
.mr10 {
  margin-right: 10px;
}
.table-td-thumb {
  display: block;
  margin: auto;
  width: 40px;
  height: 40px;
}
</style>
